import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';
import logo from '../../images/מורן וינברגר לוגו.webp';

const whatsappUrl = 'https://wa.me/972502177062?text=' +
  encodeURIComponent('היי מורן, הגעתי מהאתר שלך ואשמח שנדבר על..');

const Footer = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        {/* Top Row */}
        <div className={styles.topRow}>
          {/* Logo & Tagline */}
          <div className={styles.brandCol}>
            <img src={logo} alt="מורן הום" className={styles.logo} loading="lazy" decoding="async" />
            <p className={styles.tagline}>עיצוב פנים וניהול פרויקטים</p>
          </div>

          {/* Nav */}
          <div className={styles.navCol}>
            <h4 className={styles.colTitle}>ניווט</h4>
            <button className={styles.navBtn} onClick={() => scrollTo('שירותים')}>שירותי הסטודיו</button>
            <button className={styles.navBtn} onClick={() => scrollTo('פרוייקטים')}>פרויקטים</button>
            <button className={styles.navBtn} onClick={() => scrollTo('מי-אני')}>קצת עלי</button>
            <button className={styles.navBtn} onClick={() => scrollTo('שאלות-תשובות')}>שאלות תשובות</button>
          </div>

          {/* Contact */}
          <div className={styles.contactCol}>
            <h4 className={styles.colTitle}>צרו קשר</h4>
            <a href="tel:+972502177062" className={styles.contactLink}>050-217-7062</a>
            <a href="mailto:mazalmoran24@gmail.com" className={styles.contactLink}>mazalmoran24@gmail.com</a>
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className={styles.contactLink}>שלחו הודעה בוואטסאפ</a>
          </div>

          {/* Social */}
          <div className={styles.socialCol}>
            <h4 className={styles.colTitle}>עקבו אחרי</h4>
            <div className={styles.socialIcons}>
              <a href="https://www.instagram.com/moranw.home/" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="Instagram">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" />
                  <circle cx="12" cy="12" r="5" />
                  <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor" stroke="none" />
                </svg>
              </a>
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="WhatsApp">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className={styles.divider} />

        {/* Bottom Row */}
        <div className={styles.bottomRow}>
          <p className={styles.copyright}>
            &copy; {new Date().getFullYear()} מורן הום. כל הזכויות שמורות.
          </p>
          <div className={styles.legalLinks}>
            <Link to="/privacy" className={styles.privacyLink}>
              תקנון ומדיניות פרטיות
            </Link>
            <a
              href="/accessibility"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.privacyLink}
            >
              הצהרת נגישות
            </a>
          </div>
        </div>

        <p className={styles.credit}>
          נבנה על ידי{' '}
          <a href="https://danielrozenblat.co.il/" target="_blank" rel="noopener noreferrer" className={styles.creditLink}>
            דניאל רוזנבלט
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
